import * as Sentry from '@sentry/react';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { QueryErrorResetBoundary } from 'react-query';
import { NotFoundPage } from '../../pages/not-found-page/NotFoundPage';
import { DefaultSuspenseFallback } from './DefaultSuspenseFallback';

const defaultErrorBoundaryProps: Sentry.ErrorBoundaryProps = {
  fallback: () => {
    return <NotFoundPage />;
  },
};

const defaultSuspenseProps: React.SuspenseProps = {
  fallback: DefaultSuspenseFallback(),
};

type SuspenseBoundaryProps = {
  errorBoundaryProps?: Sentry.ErrorBoundaryProps;
  suspenseProps?: React.SuspenseProps;
};

export const SuspenseBoundary: React.FC<PropsWithChildren<SuspenseBoundaryProps>> = ({ children, errorBoundaryProps = defaultErrorBoundaryProps, suspenseProps = defaultSuspenseProps }) => {
  return (
    <QueryErrorResetBoundary>
      <Sentry.ErrorBoundary
        {...errorBoundaryProps}
      >
        <React.Suspense {...suspenseProps}>
          {children}
        </React.Suspense>
      </Sentry.ErrorBoundary>
    </QueryErrorResetBoundary>
  );
};

export const withSuspenseBoundary = <ComponentProps extends Record<string, unknown>>(Component: React.ComponentType<ComponentProps>, props?: SuspenseBoundaryProps) => {
  return (componentProps: ComponentProps) => (
    <SuspenseBoundary {...props}>
      <Component {...componentProps} />
    </SuspenseBoundary>
  );
};